<template>
    <div class="scroll-y custom-scrollbar">
        <ion-row>
            <ion-col size="12" size-xl="10" offset-xl="1">
                <div class="padding">

                    <h1 class="h3">Rozliczenia</h1>

                    <div class="box">
                        <form class="form form-generate-report">
                            <p class="text-bold">Zakres rozliczeń</p>
                            <ion-row>
                                <ion-col size="12" size-md="4">
                                    <div class="form-group mb-0">
                                        <label>Miesiąc:</label>
                                        <div class="select-wrapper">
                                            <span v-if="form.month === ''" class="select-placeholder">Wybierz miesiąc</span>
                                            <select v-model="form.month" @change="getBalances">
                                                <option v-for="(item,key) in monthCollection" :key="key" :value="parseInt(key)+1">{{ item }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </ion-col>
                                <ion-col size="12" size-md="4">
                                    <div class="form-group mb-0">
                                        <label>Kwartał:</label>
                                        <div class="select-wrapper">
                                            <span v-if="form.quarter === ''" class="select-placeholder">Wybierz kwartał</span>
                                            <select v-model="form.quarter" @change="getBalances">
                                                <option v-for="(item,key) in quarterCollection" :key="key" :value="parseInt(key)+1">{{ item }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </ion-col>
                                <ion-col size="12" size-md="4">
                                    <div class="form-group mb-0">
                                        <label>Rok:</label>
                                        <div class="select-wrapper">
                                            <span v-if="form.year === ''" class="select-placeholder">Wybierz rok</span>
                                            <select v-model="form.year" @change="getBalances">
                                                <option v-for="(item,key) in yearCollection" :key="key" :value="item">{{ item }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </ion-col>
                                <ion-col size="12" size-md="8">
                                    <div class="form-group">
                                        <label>Wyszukaj:</label>
                                        <input v-model="form.search" @input="searchTimeOut" type="text" placeholder="Wpisz Nazwę uczestnika lub Numer odbiorcy lub Nazwę odbiorcy"/>
                                    </div>
                                </ion-col>
                                <ion-col size="12" size-md="4" v-if="showButtonClearFilters">
                                    <div class="text-right mb-10" style="margin-top: 18px">
                                        <button class="btn btn-block btn-gray inline-block m-0" @click="clearFilters($event)">
                                            <span>Wyczyść filtry</span>
                                        </button>
                                    </div>
                                </ion-col>
                            </ion-row>
                        </form>
                    </div>

                    <h2 class="h3 text-up">Wyniki</h2>

                    <server-table ref="balancesTable" :url="'/api/v1/salesman/balances'" :params="form"></server-table>

                </div>
            </ion-col>
        </ion-row>
    </div>
</template>

<script>
    import ServerTable from "../../components/ServerTable.vue";

    export default {
        name: 'BalancesIndex',
        components: { ServerTable },
        data() {
            return {
                monthCollection: [],
                quarterCollection: [],
                yearCollection: [],

                form: {
                    month: '',
                    quarter: '',
                    year: '',
                    search: ''
                }
            }
        },
        computed: {
            showButtonClearFilters: function () {
                if(this.form.month === '' && this.form.quarter === '' && this.form.year === '' && this.form.search === ''){
                    return false
                }else{
                    return true
                }
            }
        },
        methods: {
            getBalances: function () {
                this.$refs.balancesTable.getData();
            },
            searchTimeOut: function () {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.getBalances();
                }, 500);
            },
            clearFilters: function (event) {
                event.preventDefault();
                this.form.month = '';
                this.form.quarter = '';
                this.form.year = '';
                this.form.search = '';
                this.getBalances();
            }
        }
    }
</script>